<template>
  <section>
    <MapDialog ref="mapDialog" @sub="handleMapChoose" />
    <baidu-map @ready="renderMap">
      <bm-view class="map"></bm-view>
      <bm-local-search
        :keyword="resultVal.address || ''"
        :panel="false"
        :auto-viewport="false"
        :location="location"
        @searchcomplete="searchcomplete"
      ></bm-local-search>
    </baidu-map>
    <el-autocomplete
      class="norderFormWidth"
      v-model="resultVal.address"
      :fetch-suggestions="querySearch"
      value-key="addressTitle"
      :trigger-on-focus="true"
      placeholder="请输入内容"
      @select="handleSelect"
    >
      <span
        slot="suffix"
        class="inputSlotText cur primary"
        @click="showMap('sourceAddress')"
        >选择</span
      >
    </el-autocomplete>
    <!-- <el-input
      readonly
      class="norderFormWidth"
      v-model="resultVal.address"
      placeholder="请选择"
      :disabled="disabled"
    >
      <span
        slot="suffix"
        class="inputSlotText cur primary"
        @click="showMap('sourceAddress')"
        >选择</span
      >
    </el-input> -->
  </section>
</template>

<script>
import MapDialog from './mapDialog';
import {
  findAddressId,
} from '@qx/utils';
export default {
  components: {
    MapDialog,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'cc',
  },
  props: {
    resultVal: {
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    location: {
      type: String,
      default: '全国',
    },
  },
  data () {
    return {
      BMap: null,
      suggestions: [],
    };
  },
  methods: {
    showMap (tar) {
      this.mapTar = tar;
      this.$refs.mapDialog.show();
    },
    renderMap ({ BMap, map }) {
      this.BMap = BMap;
    },
    // 获取百度检索结果
    searchcomplete (data) {
      if (data && data.Hr && data.Hr.length) {
        for (let item of data.Hr) {
          item.addressTitle = `${item.title}（${item.address}）`;
        }
        this.suggestions = data.Hr;
      }
    },
    // 将检索结果在下拉列表输出
    querySearch (queryString, cb) {
      cb(this.suggestions);
    },
    // 选中地址的经纬度获取地址更详细的信息，例如
    handleSelect (item) {
      const geoc = new this.BMap.Geocoder();
      const pt = new this.BMap.Point(item.point.lng, item.point.lat);
      geoc.getLocation(pt, (rs) => {
        const addComp = rs.addressComponents || {};
        const addressDetail = {
          province: addComp.province || item.province || '',
          city: addComp.city || item.city || '',
          district: addComp.district || '',
          street: addComp.street || '',
          streetNumber: addComp.streetNumber || '',
          title: item.title || '',
        };

        this.handleMapChoose({
          point: item.point,
          // 省+市+区+街道
          address: addressDetail.province + item.address,
          addressDetail,
        });

      });
    },
    async handleMapChoose ({ point, address, addressDetail, addressShow, provinceId, cityId, countryId }) {
      const addressInfo = {
        lat: point.lat, // 纬度
        lng: point.lng, // 经度
        // 导航地址
        address,
        // 应到地址
        addressShow: addressShow || '',
        // 地址的省市区街道
        addressDetail,
      };
      if (provinceId && cityId && countryId) {
        addressInfo.provinceId = provinceId;
        addressInfo.cityId = cityId;
        addressInfo.countryId = countryId;
      } else {
        const addressId = await findAddressId(addressDetail);
        if (addressId && addressId.provinceId) {
          addressInfo.provinceId = addressId.provinceId;
          addressInfo.cityId = addressId.cityId;
          addressInfo.countryId = addressId.countryId;
        }
      }
      this.$emit('cc', addressInfo);
    },
  },
};
</script>

<style>
</style>
